module.exports = __webpack_public_path__ + "img/password-success-icon.f15388bc.png";